// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App_b2'
import VueRouter from 'vue-router'
import VeeValidate from 'vee-validate'
import VueResource from 'vue-resource'
import calendar from '@/components/calendar'
import calendarselect from '@/components/calendar_select'
Vue.use(Vuex)
Vue.use(VueResource)
Vue.use(VeeValidate, {
  classes: true,
  events: 'change',
  validity: true,
  classNames: {
    valid: "is-valid",
    invalid: "is-invalid"
  }
})
Vue.use(VueRouter)
const router = new VueRouter({
    mode: 'history',
    routes: []
})
/* eslint no-extend-native: ["error", { "exceptions": ["Date"] }] */
Date.prototype.formatDate = function (format) {
  let date = this
  let day = date.getDate()
  let month = date.getMonth() + 1
  let year = date.getFullYear()
  let hours = date.getHours()
  let minutes = date.getMinutes()
  let seconds = date.getSeconds()
  let monthnames = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli','August','September','Oktober','November','Dezember']
  let daynames = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa']
  let daynamesfull = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag']
  if (!format) {
    format = "MM/dd/yyyy"
  }
  if (format.indexOf("YYYY") > -1) {
    format = format.replace("YYYY", year.toString())
  } else if (format.indexOf("YY") > -1) {
    format = format.replace("YY", year.toString().substr(2, 2))
  }
  if (format.indexOf("MMMM") > -1) {
    format = format.replace("MMMM", monthnames[date.getMonth()])
  } else if (format.indexOf("MM") > -1) {
    format = format.replace("MM", month.toString().replace(/^(\d)$/, '0$1'))
  }
  if (format.indexOf("dddd") > -1) {
    format = format.replace("dddd", daynamesfull[date.getDay()])
  } else if (format.indexOf("dd") > -1) {
    format = format.replace("dd", daynames[date.getDay()])
  }
  format = format.replace("DD", day.toString().replace(/^(\d)$/, '0$1'))
  if (format.indexOf("HH") > -1) {
    format = format.replace("HH", hours.toString().replace(/^(\d)$/, '0$1'))
  }
  if (format.indexOf("hh") > -1) {
    if (hours > 12) {
      hours -= 12
    }
    if (hours === 0) {
      hours = 12
    }
    format = format.replace("hh", hours.toString().replace(/^(\d)$/, '0$1'))
  }
  if (format.indexOf("mm") > -1) {
    format = format.replace("mm", minutes.toString().replace(/^(\d)$/, '0$1'))
  }
  if (format.indexOf("ss") > -1) {
    format = format.replace("ss", seconds.toString().replace(/^(\d)$/, '0$1'))
  }
  return format
}
Date.prototype.getWeekNumber = function () {
  let d = new Date(Date.UTC(this.getFullYear(), this.getMonth(), this.getDate()))
  var dayNum = d.getUTCDay() || 7
  d.setUTCDate(d.getUTCDate() + 4 - dayNum)
  let yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1))
  return Math.ceil((((d - yearStart) / 86400000) + 1) / 7)
}
Vue.config.productionTip = false
const store = new Vuex.Store({
  state: {
    selectedevents: [],
    calendars: [],
    calendarselect: [],
    calendarevents: [],
    actions: [],
    actions2: [],
    actions3: [],
    shoplinks: [],
    shopproducts: [],
    voucherlinks: [],
    showandhideactions: [],
    cookiesettings: [],
    SearchParams: [],
    showmodalgeneralrequest: false,
    showmodalgeneralrequestmodus: '',
    showmodalshoppingcart: false,
    showmodalshop: false,
    showmodalvoucherrequest: false,
    showmodalcourserequest: false,
    showmodalcourserequestname: '',
    showstickysidebar: false,
    showstickynavbar: false,
    showcookieconsent: false,
    showcookieconsentmobil: false,
    showcookieconsentmobilfull: false,
    showcookiegetmore: false,
    locations: [],
    services: [],
    firstday: new Date(),
    lastday: new Date(),
    serveruri: ''
  },
  mutations: {
    addorremoveslot (state, slot) {
      let checkslot = state.selectedevents.filter(event => event.id === slot.id)
      if (checkslot.length > 0) {
        let index = state.selectedevents.findIndex(item => item.id === slot.id)
        Vue.delete(state.selectedevents, index)
      } else {
        Vue.set(state.selectedevents, state.selectedevents.length, slot)
      }
    },
    addlocations (state, data) {
      for (let i = 0; i < data.length; i++) {
        state.locations.push(data[i])
      }
    },
    addservices (state, data) {
      for (let i = 0; i < data.length; i++) {
        state.services.push(data[i])
      }
    },
    showorhideshoppingcart (state) {
      state.showmodalshoppingcart = !state.showmodalshoppingcart
    },
    showorhidemodalshop (state) {
      state.showmodalshop = !state.showmodalshop
    },
    showorhidegeneralrequest (state, modus) {
      state.showmodalgeneralrequest = !state.showmodalgeneralrequest
      state.showmodalgeneralrequestmodus = modus
    },
    showorhidevoucherrequest (state) {
      state.showmodalvoucherrequest = !state.showmodalvoucherrequest
    },
    showorhidecourserequest (state) {
      state.showmodalcourserequest = !state.showmodalcourserequest
    },
    showcookieconsent (state, status) {
      state.showcookieconsent = status
    },
    showcookieconsentmobil (state, status) {
      state.showcookieconsentmobil = status
    },
    showcookieconsentmobilfull (state, status) {
      state.showcookieconsentmobilmobil = status
    },
    showcookiegetmore (state, status) {
      state.showcookiegetmore = status
    },
    clearcart (state) {
      state.selectedevents = []
    },
  }
})

/* eslint-disable no-new */
new Vue({
  el: document.querySelector('#app'),
  store,
  template: '<App/>',
  components: { App, calendar, calendarselect },
  created: function () {
    if (process.env.NODE_ENV === 'development') {
      store.state.uri = '/calendarrequest'
    } else if (process.env.NODE_ENV === 'production') {
      store.state.uri = 'https://api.mycrogym.com/calendarrequest/'
    }
    store.state.firstday = new Date()
    store.state.firstday.setHours(0,0,0)
    store.state.lastday = new Date()
    store.state.lastday.setDate(store.state.lastday.getDate() + 13)
    store.state.lastday.setHours(23,59,0)
    var self = this
    store.state.actions2 = document.getElementsByClassName('consultation')
    for (let i = 0; i < store.state.actions2.length; i++) {
      store.state.actions2[i].addEventListener("click", ( e ) => {
        store.state.showmodalgeneralrequestmodus = 'Beratungsgespräch'
        store.state.showmodalgeneralrequest = true
      }, { passive: true })
    }
    store.state.actions3 = document.getElementsByClassName('courserequest')
    for (let i = 0; i < store.state.actions3.length; i++) {
      store.state.actions3[i].addEventListener("click", ( e ) => {
        store.state.showmodalcourserequest = true
        store.state.showmodalcourserequestname = e.target.dataset.text
        console.log(e.target.dataset.text)
      })
    }
    store.state.cookiesettings = document.getElementsByClassName('cookiesettings')
    for (let i = 0; i < store.state.cookiesettings.length; i++) {
      store.state.cookiesettings[i].addEventListener("click", ( e ) => {
        store.state.showcookieconsent = true
        store.state.showcookieconsentmobil = false
        store.state.showcookiegetmore = true
      }, { passive: true })
    }
    store.state.voucherlinks = document.getElementsByClassName('getvoucher')
    for (let i = 0; i < store.state.voucherlinks.length; i++) {
      store.state.voucherlinks[i].addEventListener("click", ( e ) => {
        store.state.showmodalvoucherrequest = true
      })
    }
    store.state.actions = document.getElementsByClassName('trailPractice')
    for (let i = 0; i < store.state.actions.length; i++) {
      store.state.actions[i].addEventListener("click", ( e ) => {
        store.state.showmodalgeneralrequestmodus = 'Probetraining'
        store.state.showmodalgeneralrequest = true
      })
    }
    store.state.shoplinks = document.getElementsByClassName('shop')
    for (let i = 0; i < store.state.shoplinks.length; i++) {
      store.state.shoplinks[i].addEventListener("click", ( e ) => {
        store.state.showmodalshop = true
        Vue.set(store.state, 'shopproducts', JSON.parse(store.state.shoplinks[i].dataset.products))
        Vue.set(store.state, 'shopmode', store.state.shoplinks[i].dataset.mode)
      })
    }
    store.state.showandhideactions = document.querySelectorAll("mycrogymshoworhide")
    let uri = window.location.search.substring(1)
    store.state.SearchParams = new URLSearchParams(uri)
    store.state.calendars = document.querySelectorAll("mycrogymcalendar")
    store.state.calendarselects = document.querySelectorAll("mycrogymcalendarselect")
    let app = document.querySelector('#appconfig')
    if (app.dataset.showstickysidebar === 'true') store.state.showstickysidebar = true
    if (app.dataset.showstickynavbar === 'true') store.state.showstickynavbar = true
    if (store.state.calendarselects.length === 0) {
      let today = new Date()
      let payload = {}
      payload.companyid = app.dataset.companyid
      payload.locations = app.dataset.locations
      payload.services = app.dataset.services
      payload.firstday = store.state.firstday.formatDate("YYYY-MM-DD HH:mm:ss")
      payload.lastday = store.state.lastday.formatDate("YYYY-MM-DD HH:mm:ss")
      this.$http.post(store.state.uri, JSON.stringify(payload))
        .then(function (response) {
          let results = []
          let array = []
          array = JSON.parse(response.body)
          store.commit('addservices',array.services)
          store.commit('addlocations',array.locations)
          store.state.calendarevents = array.calendarevents
        }, function (reason) {

        })
    }
  },
  mounted: function () {
    this.renderCalendar()
    this.showorhideactions()
  },
  beforeDestroy: function () {
    for (let i = 0; i < store.state.actions.length; i++) {
      store.state.actions[i].removeEventListener("click", null)
    }
    for (let i = 0; i < store.state.actions2.length; i++) {
      store.state.actions2[i].removeEventListener("click", null)
    }
    for (let i = 0; i < store.state.actions3.length; i++) {
      store.state.actions3[i].removeEventListener("click", null)
    }
    for (let i = 0; i < store.state.voucherlinks.length; i++) {
      store.state.voucherlinks[i].removeEventListener("click", null)
    }
  },
  methods: {
    showorhideactions () {
      for (let i = 0; i < store.state.showandhideactions.length; i++) {
        if (typeof store.state.showandhideactions[i].dataset.action !== 'undefined' && typeof store.state.showandhideactions[i].dataset.name !== 'undefined' && typeof store.state.showandhideactions[i].dataset.value !== 'undefined') {
          if (store.state.SearchParams.has(store.state.showandhideactions[i].dataset.name) && store.state.SearchParams.get(store.state.showandhideactions[i].dataset.value)) {
            if (store.state.showandhideactions[i].dataset.function === 'if') {
              if (store.state.showandhideactions[i].dataset.action === 'show') {
                store.state.showandhideactions[i].style.display = ''
              } else if (store.state.showandhideactions[i].dataset.action === 'hide') {
                store.state.showandhideactions[i].style.display = 'none'
              }
            } else if (store.state.showandhideactions[i].dataset.function === 'ifnot') {
              if (store.state.showandhideactions[i].dataset.action === 'show') {
                store.state.showandhideactions[i].style.display = 'none'
              } else if (store.state.showandhideactions[i].dataset.action === 'hide') {
                store.state.showandhideactions[i].style.display = ''
              }
            }
          } else {
            if (store.state.showandhideactions[i].dataset.function === 'if') {
              if (store.state.showandhideactions[i].dataset.action === 'show') {
                store.state.showandhideactions[i].style.display = 'none'
              } else if (store.state.showandhideactions[i].dataset.action === 'hide') {
                store.state.showandhideactions[i].style.display = ''
              }
            } else if (store.state.showandhideactions[i].dataset.function === 'ifnot') {
              if (store.state.showandhideactions[i].dataset.action === 'show') {
                store.state.showandhideactions[i].style.display = ''
              } else if (store.state.showandhideactions[i].dataset.action === 'hide') {
                store.state.showandhideactions[i].style.display = 'none'
              }
            }
          }
        }
      }
    },
    renderCalendar () {
      for (let i = 0; i < store.state.calendars.length; i++) {
        let item = store.state.calendars[i]
        let companyid = item.dataset.companyid
        let locations = item.dataset.locations
        let services = item.dataset.services
        var ComponentClass = Vue.extend(calendar)
        var instance = new ComponentClass({
            propsData: { companyid: companyid, definedlocations: locations, definedservices: services },
            store
        })
        instance.$mount()
        store.state.calendars[i].appendChild(instance.$el)
      }
      for (let i = 0; i < store.state.calendarselects.length; i++) {
        let item = store.state.calendarselects[i]
        let companyid = item.dataset.companyid
        let locations = item.dataset.locations
        let services = item.dataset.services
        var ComponentClass = Vue.extend(calendarselect)
        var instance = new ComponentClass({
            propsData: { companyid: companyid, definedlocations: locations, definedservices: services },
            store
        })
        instance.$mount()
        store.state.calendarselects[i].appendChild(instance.$el)
      }
      return false
    }
  }
})
